import promociones from '@/pages/promociones/promociones'

const defaultMeta = {
  requiresAuth: true,
  roles: [
    'VD_ADMINISTRADOR'
  ]
}

const routes = [
  {
    path: '/promociones',
    component: promociones,
    name: 'promociones.list'
  }
].map(r => {
  return {
    ...r,
    meta: Object.assign({}, defaultMeta, r.meta)
  }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/promociones.js